import { v4 as uuidv4 } from 'uuid';
import type { ChatMessage } from '../types';

interface DbMessageRow {
  id?: string;
  sequence: number;
  content: any;
  createdAt: string;
}

export function hydrateMessages(rows: DbMessageRow[]): ChatMessage[] {
  const out: ChatMessage[] = [];
  for (const row of rows) {
    const m = row.content;
    const ts = new Date(row.createdAt).getTime();

    if (m?.role === 'user') {
      let text = '';
      const images: string[] = [];
      if (typeof m.content === 'string') {
        text = m.content;
      } else if (Array.isArray(m.content)) {
        for (const p of m.content) {
          if (p?.type === 'text') text += p.text ?? '';
          else if (p?.type === 'image_url' && p.image_url?.url)
            images.push(p.image_url.url);
        }
      }
      out.push({
        id: row.id ?? uuidv4(),
        backendId: row.id,
        role: 'user',
        text,
        timestamp: ts,
        images: images.length ? images : undefined,
      });
    } else if (
      m?.role === 'assistant' &&
      typeof m.content === 'string' &&
      m.content
    ) {
      out.push({
        id: row.id ?? uuidv4(),
        backendId: row.id,
        role: 'assistant',
        text: m.content,
        timestamp: ts,
      });
    }
  }
  return out;
}
